import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// mui
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
// components
import TopBackButton from '@/component/common/top-back-button';
import SFStepper from '@/component/common/sf-stepper';
import SFCheckbox from '@/component/common/sf-checkbox';
import SFSimpleCheckbox from '@/component/common/sf-simple-checkbox';
import ArrowLinkButton from '@/component/common/arrow-link-button';
import BottomFix from '@/component/common/bottom-fix';
// lib
import { SFPalette } from '@/lib/color';
import { deleteStorage, getStorage } from '@/lib/storage';
// api
import { termsList } from '@/api/server/terms/read';
import ErrorRes from '@/api/server/ErrorRes';
import { createSnsUser } from '@/api/server/user/create';
// store
import { useTermsInfoActions, useJoinInfoActions, JoinState } from '@/store/zustand/store';

type termListProps = {
  terms_id: string;
  seq: number;
  terms_type: string;
  terms_ver: string;
  title: string;
  post: any;
};

const AgreeForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [terms, setTerms] = useState({
  //   tt01: false,
  //   tt02: false,
  //   tt03: false,
  //   tt04: false,
  //   tt05: false,
  //   tt06: false,
  // });
  const [serviceAgreement, setServiceAgreement] = useState(false);
  const [electronicFinancialTransaction, setElectronicFinancialTransaction] = useState(false);
  const [electronicCommerce, setElectronicCommerce] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [privacyAgreement, setPrivacyAgreement] = useState(false);
  const [marketingAgreement, setMarketingAgreement] = useState(false);

  const [termList, setTermList] = useState<termListProps[]>([]);
  const { setTermsInfo } = useTermsInfoActions();
  const { setJoinInfo } = useJoinInfoActions();
  const [isSnsJoin, setIsSnsJoin] = useState(false);
  const email = useRef('');
  useEffect(() => {
    (async () => {
      const re = await termsList();
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setTermList(re.data);
    })();

    return () => {};
  }, []);

  useEffect(() => {
    const storage = getStorage('join');
    const re = storage ? JSON.parse(storage) : '';
    if (re.email) {
      setIsSnsJoin(true);
      email.current = re.email;
    }
    return () => {};
  }, []);

  // const theme = useTheme();

  const mandatory =
    serviceAgreement && electronicFinancialTransaction && electronicCommerce && privacyPolicy && privacyAgreement;
  const optional = marketingAgreement;

  const handleCheckAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setServiceAgreement(event.target.checked);
    setElectronicFinancialTransaction(event.target.checked);
    setElectronicCommerce(event.target.checked);
    setPrivacyPolicy(event.target.checked);
    setPrivacyAgreement(event.target.checked);
    setMarketingAgreement(event.target.checked);
  };

  const termView = (termsType: string) => {
    const terms = termList.filter((item) => item.terms_type === termsType)[0];
    navigate(`/terms/${terms.terms_id}/${terms.terms_type}`);
  };
  const snsJoin = async () => {
    const termArry = ['tt01', 'tt02', 'tt03', 'tt04', 'tt06'];
    if (optional) {
      termArry.push('tt05');
    }
    const payload = {
      email: email.current,
      terms_type: termArry,
    };
    const re = await createSnsUser(payload);
    if (re.ret_code !== 200) {
      ErrorRes({ code: re.ret_code, msg: re.msg, isBack: false });
      return;
    }
    const joinPayload: JoinState = { email: email.current };
    setJoinInfo(joinPayload);
    navigate('/registerPin');
  };
  return (
    <div>
      <Box py={2} px={2.5} mb={3.5} borderRadius={2} bgcolor={SFPalette.lightGrey3}>
        <FormControlLabel
          control={<SFCheckbox checked={mandatory && optional} onChange={handleCheckAllChange} />}
          label={
            <Typography variant="h6" ml={1}>
              <strong>{t('validation.allAgreeTerms')}</strong>
            </Typography>
          }
        />
      </Box>

      <Box px={2}>
        <FormControlLabel
          control={
            <SFCheckbox
              checked={mandatory}
              name="allMandatory"
              onChange={(event) => {
                const isChecked = event.target.checked;
                setServiceAgreement(isChecked);
                setElectronicFinancialTransaction(isChecked);
                setElectronicCommerce(isChecked);
                setPrivacyPolicy(isChecked);
                setPrivacyAgreement(isChecked);
              }}
            />
          }
          label={
            <Typography variant="body1" ml={1}>
              <strong>[필수] 셔플 서비스 약관 모두 동의</strong>
            </Typography>
          }
        />

        <Box>
          {/* TODO terms rnd */}
          {/* {termList.length > 0
            ? termList.map((item: termListProps) => (
                <Fragment key={item.terms_id}>
                  <Stack direction="row" alignItems="center">
                    <FormControlLabel
                      sx={{
                        flex: 1,
                      }}
                      control={
                        <SFSimpleCheckbox
                          // term: {
                          //   term-tt01,
                          //   term-tt02
                          // }
                          // checked={terms[item.terms_type]}
                          // term[item.terms_type?] 처리 가능한지 확인
                          // checked={serviceAgreement}
                          // onChange={(event) => setServiceAgreement(event.target.checked)}
                          onChange={(e) => {
                            console.log(e.target.checked);

                            setTerms({
                              ...terms,

                              // item[terms_type]: e.target.checked
                              // item[terms_type]: e.target.checked,
                            });
                          }}
                        />
                      }
                      label={<Typography variant="body2">{item.title}</Typography>}
                    />
                    <NavLink to={`/terms/${item.terms_id}`} />
                    <ArrowLinkButton
                      onClick={() => {
                        console.log('fffffffffffffffffffffffffffffff');
                        navigate(`/terms/${item.terms_id}`);
                      }}
                    />
                    <Divider sx={{ my: 2 }} />
                  </Stack>
                </Fragment>
              ))
            : ''}
          -------------------------------------------------------------------------------------------
          */}
          <Stack direction="row" alignItems="center">
            <FormControlLabel
              sx={{
                flex: 1,
              }}
              control={
                <SFSimpleCheckbox
                  checked={serviceAgreement}
                  onChange={(event) => setServiceAgreement(event.target.checked)}
                />
              }
              label={<Typography variant="body2">서비스 약관</Typography>}
            />
            <ArrowLinkButton
              onClick={async () => {
                termView('tt01');
              }}
            />
          </Stack>
          <Stack direction="row" alignItems="center">
            <FormControlLabel
              sx={{
                flex: 1,
              }}
              control={
                <SFSimpleCheckbox
                  checked={electronicFinancialTransaction}
                  onChange={(event) => setElectronicFinancialTransaction(event.target.checked)}
                />
              }
              label={<Typography variant="body2">전자금융거래 이용약관</Typography>}
            />
            <ArrowLinkButton
              onClick={async () => {
                termView('tt02');
              }}
            />
          </Stack>
          <Stack direction="row" alignItems="center">
            <FormControlLabel
              sx={{
                flex: 1,
              }}
              control={
                <SFSimpleCheckbox
                  checked={electronicCommerce}
                  onChange={(event) => setElectronicCommerce(event.target.checked)}
                />
              }
              label={<Typography variant="body2">전자상거래 이용약관</Typography>}
            />
            <ArrowLinkButton
              onClick={async () => {
                termView('tt03');
              }}
            />
          </Stack>
          <Stack direction="row" alignItems="center">
            <FormControlLabel
              sx={{
                flex: 1,
              }}
              control={
                <SFSimpleCheckbox
                  checked={privacyPolicy}
                  onChange={(event) => setPrivacyPolicy(event.target.checked)}
                />
              }
              label={<Typography variant="body2">개인정보 처리방침</Typography>}
            />
            <ArrowLinkButton
              onClick={async () => {
                termView('tt04');
              }}
            />
          </Stack>
          <Stack direction="row" alignItems="center">
            <FormControlLabel
              sx={{
                flex: 1,
              }}
              control={
                <SFSimpleCheckbox
                  checked={privacyAgreement}
                  onChange={(event) => setPrivacyAgreement(event.target.checked)}
                />
              }
              label={<Typography variant="body2">개인정보 수집 및 이용 동의</Typography>}
            />
            <ArrowLinkButton
              onClick={async () => {
                termView('tt06');
              }}
            />
          </Stack>
        </Box>
      </Box>

      <Divider
        sx={{
          my: 3.5,
        }}
      />

      <Box px={2} mb={5}>
        <FormControlLabel
          control={
            <SFCheckbox
              checked={optional}
              name="optional"
              onChange={(event) => setMarketingAgreement(event.target.checked)}
            />
          }
          label={
            <Typography variant="body1" ml={1}>
              <strong>[선택] 마케팅 정보 수신동의</strong>
            </Typography>
          }
        />
        <Stack direction="row" alignItems="center">
          <FormControlLabel
            sx={{
              flex: 1,
            }}
            control={
              <SFSimpleCheckbox
                checked={marketingAgreement}
                onChange={(event) => setMarketingAgreement(event.target.checked)}
              />
            }
            label={<Typography variant="body2">마케팅 정보 수신 동의</Typography>}
          />
          <ArrowLinkButton
            onClick={async () => {
              termView('tt05');
            }}
          />
        </Stack>
      </Box>

      <BottomFix>
        <Button
          variant="contained"
          disabled={!mandatory}
          fullWidth
          size="large"
          sx={{
            my: 2,
          }}
          onClick={() => {
            if (isSnsJoin) {
              (async () => {
                await snsJoin();
                deleteStorage('join');
              })();
            } else {
              const payload = {
                mandatory,
                optional,
              };
              setTermsInfo(payload);
              navigate('/signUp');
            }
          }}
        >
          확인
        </Button>
      </BottomFix>
    </div>
  );
};

export default function AgreeTerms() {
  return (
    <Container maxWidth="sm">
      <Box position="sticky" top={0} bgcolor="white" zIndex={100}>
        <TopBackButton
          title="회원가입"
          boxProps={{
            mb: 2,
          }}
          backPath="/signInSns"
        />
        <SFStepper
          steps={['1', '2', '3', '4']}
          activeStep={0}
          stepperProps={{
            sx: {
              width: 200,
              ml: '-10px',
              pb: 2,
            },
          }}
        />
      </Box>
      <Box pt={4}>
        <Typography variant="h4" mb={3.5}>
          {'반갑습니다 :)'}
          <br />
          <strong>가입약관을 확인해 주세요!</strong>
        </Typography>
        <AgreeForm />
      </Box>
    </Container>
  );
}
